// extracted by mini-css-extract-plugin
module.exports = {"category__wrapper":"styles_category__wrapper__YJL6C","list":"styles_list__2ODGg","tag":"styles_tag__12sdV","bg":"styles_bg__2v8UW"};